import React, { Component } from 'react';
import Loader from 'react-loader-advanced';
import ReactLoading from 'react-loading';
import { store } from "../../../testStore";

/* React Router */
import { withRouter } from 'react-router-dom'

/* Result */
import Result from 'iotera-base/result'

/* Redux */
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux';

/* Sagas Action */
import { buildWBoundActions, buildWSelector } from '../../../redux/ducks'
import { actions as notificationActions } from '../../../redux/ducks/notification'

/* Routes */
import { domainIsTenant as dit, S } from '../../../routes/routes'

/* Object Json */
import { isEmpty, isFunction } from 'iotera-base/object';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { SubViewHeader } from '../../../lib/components/subHeader';
import { SortableContainer, SortableElement, SortableHandle } from 'react-sortable-hoc';
import arrayMove from 'array-move'

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import DragIcon from '@material-ui/icons/DragHandle';
import { setRoleEmpty } from '../../../testActions';
import { IoteraForm } from '../../../lib/components/form';
import { InlineTooltip } from '../../../lib/components/tooltips';
import { setCallbackGlobal, unsetCallbackGlobal } from '../../../lib/components/callbackGlobal';

const EDIT = "EDIT_ACCESS";
const WKEY = "ROLE_EDIT";
const wSelector = buildWSelector(WKEY);
const wBoundActions = buildWBoundActions(WKEY);

const DragHandle = SortableHandle(() => <span style={{ cursor: 'row-resize', marginRight: 10 }}><DragIcon /></span>);

const SortableItem = SortableElement(({ value, value2 }) =>
  <ListItem className='stylizedItem' >
    <DragHandle />
    <span className='head-iotera-path'>
      {value2 !== '' ? './' + value2 + '/' : './'}
    </span>
    {value}
  </ListItem>
);

const SortableList = SortableContainer(({ items }) => {
  return (
    <List className="stylizedList" style={{ padding: 0 }}>
      {items.map((value, index) => (
        <SortableItem key={`item-${index}`} index={index} value={value.label} value2={safeDeepGetWithType(value, ['parentLabel'], '')} />
      ))}
    </List>
  );
});

class SortableComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      itemsId: props.dataId,
      items: props.data
    }
  }

  onSortEnd = ({ oldIndex, newIndex }) => {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    let items = arrayMove(_state.items, oldIndex, newIndex);
    let itemsId = arrayMove(_state.itemsId, oldIndex, newIndex);
    let onChange = safeDeepGetWithType(_props, ['onChange']);
    if (isFunction(onChange)) {
      onChange(items, itemsId);
    }
    _this.setState({ items, itemsId })
  };

  render() {
    const _this = this;
    const _state = _this.state
    return <SortableList items={_state.items} onSortEnd={_this.onSortEnd} useDragHandle />;
  }
}

function navsWithParentLabel(navsId, navs, navsArr, navsObj) {
  for (let i = 0; i < navsArr.length; i++) {
    let id = safeDeepGetWithType(navsArr, [i, 'id'], '');
    let label = safeDeepGetWithType(navsArr, [i, 'label'], '');
    let path = safeDeepGetWithType(navsArr, [i, 'path'], '');
    let parent = safeDeepGetWithType(navsArr, [i, 'parent'], '');
    if (parent === '') {
      parent = safeDeepGetWithType(navsArr, [i, '_parent'], '');
    }
    navsId.push(
      navsArr[i].id
    );
    let navParent = safeDeepGetWithType(navsObj, [parent], {});
    let parentLabel = safeDeepGetWithType(navParent, ['label'], '');
    let navsBody = {
      id,
      label,
      path,
      parent,
      parentLabel
    }
    navs.push(
      navsBody
    );
  }
}

class RoleEditSort extends Component {
  constructor(props) {
    super(props)
    let storeValue = store.getState();
    let dataToShow = storeValue;
    if (isEmpty(dataToShow)) {
      this.goBack();
    } else {
      if ('role' in dataToShow) {
        if (isEmpty(dataToShow.role)) {
          this.goBack();
        } else {
          dataToShow = dataToShow.role;
        }
      } else {
        this.goBack();
      }
    }
    let isDirect = safeDeepGetWithType(dataToShow, ['direct'], true)
    let navsArr = safeDeepGetWithType(dataToShow, ['navs'], []);
    let navsObj = safeDeepGetWithType(dataToShow, ['navsObj'], {});
    let descendant = safeDeepGetWithType(dataToShow, ['descendant'], false);
    let navs = [];
    let navsId = [];
    navsWithParentLabel(navsId, navs, navsArr, navsObj);
    const roleId = safeDeepGet(this, ['props', 'match', 'params', 'id']);
    this.state = {
      value: [],
      formData: dataToShow,
      roleId,
      values: '',
      isSubmit: false,
      loading: false,
      descendant: descendant,
      isDirect,
      navs,
      navsId
    }
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { roleId } = _state;
    if (isEmpty(roleId)) {
      return {}
    }
    const domainIsTenant = dit(_props);
    // callback global
    setCallbackGlobal(_props)
    _props.wInitRequestCall(
      {
        wparam: { ...domainIsTenant, path: "/service/web/application/account/role/get/id/" + roleId },
        wcallback: {
          started: function (id) {
            // TODO Loading
          },
          finished: function (id, result) {
            let navsOld = safeDeepGetWithType(result, ['body', 'navs_root'], [])
            if (navsOld.length === 0) {
              navsOld = safeDeepGetWithType(result, ['body', 'navs_root_arr'], [])
            } else {
            }
            let navsObj = safeDeepGetWithType(result, ['body', 'navs_root_obj'], {})
            let navsId = [];
            let navs = [];
            navsWithParentLabel(navsId, navs, navsOld, navsObj);
            let navsIdState = safeDeepGetWithType(_state, ['navsId'], []);
            // TODO Loading
            if (navsIdState.length > 0) {
              _this.setState({
                loading: false
              })
            } else {
              _this.setState({
                navs,
                navsId,
                loading: false
              })
            }
          }
        }
      }
    );
    _props.wSetConfig({
      single_config: {
        [EDIT]: {
          wparam: {
            ...domainIsTenant,
            method: "POST",
            path: "/service/web/application/account/role/edit"
          },
          wcallback: {
            finished: function (id, result) {
              if (result.code === Result.HTTP.OK) {
                const responseResult = safeDeepGetWithType(result, ['body', 'response_result'], Result.UNKNOWN_ERROR);
                if (responseResult === Result.SUCCESS) {
                  let action = setRoleEmpty();
                  store.dispatch(action)
                  _props.history.push('..' + S + '_role_list_');
                  _this.setState({
                    loading: false
                  })
                  _props.showSingleNotification({ message: 'Edit Role Sukses', level: 'success' });
                  return;
                }
              }
              _this.setState({
                loading: false
              })
              _props.showSingleNotification({ message: 'Edit Role Gagal', position: 'tr', level: 'error' });
            }
          }
        }
      }
    });
  }

  goTo(link) {
    this.props.history.push(link)
  }

  componentWillUnmount() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { roleId } = _state;
    if (isEmpty(roleId)) {
      return {}
    }
    // callback global
    unsetCallbackGlobal(_props)
    _props.wUnsetConfig({ key: WKEY });
  }


  handleSubmit(event) {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const roleId = safeDeepGetWithType(_state, ['roleId'], '');
    if (roleId === '') {
      return;
    }
    let descendant = safeDeepGetWithType(_state, ['descendant'], false);
    let navsId = safeDeepGetWithType(_state, ['navsId'], []);
    this.setState({
      loading: true
    })
    _props.wSingleRequestCall({
      id: EDIT,
      body: {
        id: roleId,
        descendant,
        navs: navsId,
      }
    });
  }

  goBack() {
    this.props.history.push('..' + S + '_role_list_')
  };

  onChange(navs, navsId) {
    this.setState({ navs, navsId })
  }

  render() {
    const _this = this;
    const _props = _this.props
    const _state = _this.state
    const { loading } = _state;
    let navs = _state.navs;
    let isEmptyNavs = navs.length === 0 ? true : false;
    const spinner =
      <div className='centeringItem'>
        <ReactLoading type='bubbles' color='#000' />
      </div>
    let backString = _state.isDirect ? 'Batal' : 'Kembali'
    return (
      isEmptyNavs ?
        <Loader show={isEmptyNavs} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
          </div>
        </Loader>
        :
        <Loader show={loading} message={spinner} backgroundStyle={{ backgroundColor: '#ffffff', opacity: 0.3 }}>
          <div className="view">
            <SubViewHeader title='Edit Role' subTitle='Formulir Pengaturan Urutan Akses' />
            <div className="io-container mt-12">
              <IoteraForm
                schema={{}}
                uiSchema={{}}
                onSubmit={_this.handleSubmit}
              >
                <label style={{ marginBottom: 7 }}>
                  <b>Atur Urutan Navigasi*</b>
                  <InlineTooltip id={'test'} text={'Akan ditampilkan urut dari atas ke bawah'} />
                </label>
                <SortableComponent data={_state.navs} dataId={_state.navsId} onChange={_this.onChange} />
                <div className="button-right" style={{ marginTop: 10 }}>
                  <button className="button-iotera-white" type="button" style={{ minWidth: '0%' }}
                    onClick={_props.history.goBack} >{backString}</button>
                  <button className="button-iotera-primary" type="submit" style={{ marginLeft: 10, minWidth: '0%' }}>Simpan</button>
                </div>
              </IoteraForm>
            </div>
          </div>
        </Loader>
    );
  }
}

const mapStateToProps = function (state) {
  return {
    role: wSelector.getSoleInitMappedRPayload(state),
    roleId: wSelector.getSoleInitMappedRPayload(state, 'id')
  }
}

const mapDispatchToProps = function (dispatch) {
  return {
    ...wBoundActions(dispatch),
    ...bindActionCreators(notificationActions, dispatch)
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RoleEditSort));